import { render, staticRenderFns } from "./button-widget.vue?vue&type=template&id=7357179f&scoped=true"
import script from "./button-widget.vue?vue&type=script&lang=js"
export * from "./button-widget.vue?vue&type=script&lang=js"
import style0 from "./button-widget.vue?vue&type=style&index=0&id=7357179f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7357179f",
  null
  
)

export default component.exports